import React, {useState} from 'react';
import cx from 'classnames';

import {REGEXP} from 'configs';
import {Input, InputGroup, InputGroupAddon, InputGroupText} from 'reactstrap';
import MuiIcon from 'components/Icons/MuiIcon';

InputPassword.defaultProps = {
  name: 'password',
  type: 'password',
  autoComplete: 'off',
  pattern: REGEXP.password,
  confirm: true,
};

function InputPassword(props) {
  const {type, children, className, onChange, confirm, ...rest} = props;
  const [show, setShow] = useState(false);

  function handleChange(e) {
    const target = e.target;
    const inputGroup = target.closest('.input-group');

    if (confirm) {
      if (target.checkValidity()) {
        inputGroup.classList.remove('is-invalid');
      } else {
        inputGroup.classList.add('is-invalid');
      }
    }

    if (onChange) onChange(e);
  }

  function handleShow(e) {
    e.preventDefault();
    setShow(!show);
  }

  return (
    <InputGroup className={cx('input-group-merge', className)}>
      <Input type={show ? 'text' : type} onKeyUp={handleChange} {...rest} />

      <InputGroupAddon addonType="append">
        <InputGroupText className="btn" role="button" onClick={handleShow}>
          <MuiIcon name={show ? 'visibility_off' : 'visibility'} />
        </InputGroupText>
      </InputGroupAddon>

      {children}
    </InputGroup>
  );
}

export default InputPassword;
